var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmileLightSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.12918C1 1.5769 1.44772 1.12918 2 1.12918H15C15.5523 1.12918 16 1.5769 16 2.12918V16.1788L13.1857 14.1558C12.6755 13.7891 12.063 13.5918 11.4347 13.5918H2C1.44772 13.5918 1 13.1441 1 12.5918V2.12918Z",
    stroke: "#1847CA",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4.12918,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#1847CA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8.12918,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#1847CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileLightSmall);
export default __webpack_public_path__ + "static/media/smile-light-small.03ef3803381d0659a9b0b8a3380cbedf.svg";
export { ForwardRef as ReactComponent };